<template>
    <div class="subscription">
        <div v-if="step === 1">
            <h1 v-if="
                     !isSubscribed
                     && user.trial_ends_at
                     && moment(user.trial_ends_at) > moment()
                     && moment(user.trial_ends_at) < moment().add(trialLength, 'days')
            ">
                Your trial is coming to an end.<br />Please subscribe here.
            </h1>
            <h1 v-if="
                     !isSubscribed
                     && user.trial_ends_at
                     && moment(user.trial_ends_at) < moment()
            ">
                Your trial has ended.<br />Please subscribe here.
            </h1>
            <p v-if="!isSubscribed">
                If you're not satisfied, there's a 90 day MONEY BACK GUARANTEE, less what Braintree, our secure payment system provider, charges for refunds.
            </p>
            <div class="subscription__plan subscription__plan--yearly"
                 v-bind:class="{ 'is-selected' : selectedPlan === 'yearly' }"
            >
                <div class="subscription__plan__price"
                     v-on:click="selectPlan('yearly')"
                >
                    ${{ priceYearly }}<sub> / year</sub>
                </div>
                <div class="subscription__plan__description">
                    Save 20% per year<br />{{ trialLength }} days free!
                </div>
            </div>
            <div class="subscription__plan subscription__plan--monthly"
                 v-bind:class="{ 'is-selected' : selectedPlan === 'monthly' }"
            >
                <div class="subscription__plan__price"
                     v-on:click="selectPlan('monthly')"
                >
                    ${{ priceMonthly }}<sub> / month</sub>
                </div>
                <div class="subscription__plan__description">
                    Pay as you go<br />{{ trialLength }} days free!
                </div>
            </div>
        </div>
        <div v-if="step === 2">
            <h1>pay securely.<br />no commitment.<br />cancel anytime.</h1>
        </div>
        <form class="subscription__form" autocomplete="off" v-on:submit="updateSubscription">
            <input name="plan" type="hidden" v-bind:value="selectedPlan" />
            <input name="coupon" type="hidden" v-bind:value="coupon.braintree_discount_id" v-if="coupon" />

            <input class="is-hidden" name="dummy" type="password" />

            <div v-if="step === 1 && !isSubscribed">
                <div class="subscription__input" v-bind:class="{ 'has-error' : couponError }">
                    <input id="promo" name="promo" type="text" placeholder="Got a promo code? Enter it here"
                           v-model="couponCode"
                           v-on:keyup.enter="applyCoupon"
                    />
                    <a class="subscription__input__btn" v-on:click="applyCoupon">Apply</a>
                    <span class="subscription__help-block" v-if="couponError">{{ couponError }}</span>
                </div>

                <div class="subscription__total">
                    Total to pay: <span>${{ pricePaid }}</span>
                </div>

                <p class="subscription__terms">
                    <label>
                        <div class="subscription__terms__checkbox">
                            <input type="checkbox" v-model="terms" />
                            <span></span>
                        </div>
                        I agree with <a href="/terms-of-use">terms and conditions</a>*.
                    </label>
                </p>

                <button class="subscription__btn is-block is-red"
                   v-bind:disabled="!terms || couponCheckInProgress"
                   v-html="coupon ? 'Submit coupon' : 'Proceed to payment'"
                   v-if="pricePaid !== 0"
                   v-on:click="gotoStep(2)"
                >
                </button>
                <button class="subscription__btn is-block is-red" type="submit"
                        v-bind:disabled="!terms"
                        v-if="pricePaid === 0"
                >
                    Submit coupon
                </button>

                <div class="subscription__payment-methods"
                     v-on:click="pricePaid !== 0 ? gotoStep(2) : updateSubscription($event)"
                >
                    <span class="subscription__payment-methods__paypal">PayPal</span>
                    <span>or</span>
                    <span>credit card</span>
                </div>

                <div class="subscription__braintree-notice">
                    <small>Our payment methods are secure and trusted, provided by Braintree.</small>
                    <a href="https://www.braintreegateway.com/merchants/dfcxqckjrznvdgpw/verified" target="_blank">
                        <img src="https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-light.png" width="140px" height="22px" border="0"/>
                    </a>
                </div>
            </div>

            <a class="subscription__cancel-btn" v-if="step === 1 && isSubscribed && !isOnGracePeriod" v-on:click="cancelSubscription">Cancel subscription</a>

            <div v-show="step === 2">
                <div class="subscription__card">
                    <div class="subscription__card__number">
                        <div class="subscription__input" v-bind:class="{ 'has-error' : cardError.number }">
                            <label for="credit-card-number">Card Number</label>
                            <div class="subscription__card__number__hosted-field" id="card-number"></div>
                            <span class="subscription__help-block" v-if="cardError.number">{{ cardError.number }}</span>
                            <span class="subscription__help-block" v-if="!cardError.number && cardType">{{ cardType }}</span>
                        </div>
                    </div>
                    <div class="subscription__card__expiry-cvv">
                        <div class="subscription__input" v-bind:class="{ 'has-error' : cardError.expiry }">
                            <label for="expiration">Expiry date</label>
                            <div class="subscription__card__number__hosted-field" id="card-expiry"></div>
                            <span class="subscription__help-block" v-if="cardError.expiry">{{ cardError.expiry }}</span>
                        </div>
                        <div class="subscription__input" v-bind:class="{ 'has-error' : cardError.cvv }">
                            <label for="cvv">CVV</label>
                            <div class="subscription__card__number__hosted-field" id="card-cvv"></div>
                            <span class="subscription__help-block" v-if="cardError.cvv">{{ cardError.cvv }}</span>
                        </div>
                    </div>
                </div>

                <div class="has-text-centered">
                    <button class="subscription__btn has-margin-b15" type="submit" v-bind:disabled="actionDisabled">Pay with card</button>
                    <a class="subscription__back-btn" v-on:click="gotoStep(1)">Change subscription plan</a>
                </div>
                <p id="paypal-button"></p>

                <div class="subscription__braintree-notice">
                    <small>Our payment methods are secure and trusted, provided by Braintree.</small>
                    <a href="https://www.braintreegateway.com/merchants/dfcxqckjrznvdgpw/verified" target="_blank">
                        <img src="https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-light.png" width="140px" height="22px" border="0"/>
                    </a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import _ from 'lodash';
    import braintree from 'braintree-web';
    import moment from 'moment';
    import paypal from 'paypal-checkout';

    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            this.pushGtmProductInfo();

            if (!this.isSubscribed) {
                this.braintreeSetup();
            }

            if (this.currentPlan && this.currentPlan !== this.selectedPlan) {
                this.selectedPlan = this.currentPlan;
            }
        },
        data: function () {
            return {
                actionDisabled: true,
                cardError: {
                    number: null,
                    expiry: null,
                    cvv: null
                },
                cardType: null,
                cardValid: {
                    number: false,
                    expiry: false,
                    cvv: false
                },
                coupon: null,
                couponCheckInProgress: false,
                couponCode: null,
                couponError: null,
                hostedFields: null,
                moment: moment,
                paypalPayload: null,
                pricePaid: this.priceYearly,
                selectedPlan: 'yearly',
                step: 1,
                terms: false
            }
        },
        methods: {
            applyCoupon: function () {
                eventBus.$emit('show-loader');
                this.couponCheckInProgress = true;

                this.$http.get('/api/subscription/coupon/' + this.couponCode).then(function(response) {
                    if (response.body) {
                        this.coupon = response.body;
                        this.couponError = null;

                        if (this.coupon.plan_type !== this.selectedPlan) {
                            this.coupon = null;
                            this.couponError = 'The `' + this.couponCode + '` coupon cannot be applied to ' + this.selectedPlan + ' plans.';
                            this.couponCode = null;

                            window.dataLayer.push({
                                'event': 'error',
                                'error': 'This coupon code cannot be applied to ' + this.selectedPlan + ' plans.'
                            });
                        } else {
                            this.pricePaid -= this.coupon.amount;

                            if (this.pricePaid < 0) {
                                this.pricePaid = 0;
                            }
                        }
                    }

                    this.couponCheckInProgress = false;
                    eventBus.$emit('hide-loader');
                }, function(response) {
                    if (response.status === 404) {
                        this.couponError = '`' + this.couponCode + '` is an invalid coupon code.';
                        this.couponCode = null;

                        this.pricePaid = this.selectedPlan === 'yearly'
                            ? this.priceYearly
                            : this.priceMonthly;
                    } else {
                        console.error('ERROR: there was an error fetching coupon code.');

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'error',
                                'error': 'There was an error fetching coupon code.'
                            });
                        }
                    }

                    this.couponCheckInProgress = false;
                    eventBus.$emit('hide-loader');
                });
            },
            braintreeSetup: function () {
                braintree.client.create({
                    authorization: this.braintreeAuthorization
                }, function(err, clientInstance) {
                    if (err) {
                        console.error(err);
                        return;
                    }

                    braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function(err, paypalCheckoutInstance) {
                        if (err) {
                            console.error(err);

                            if (window.dataLayer) {
                                window.dataLayer.push({
                                    'event': 'error',
                                    'error': 'There was an error setting up Braintree.'
                                });
                            }

                            return;
                        }

                        return paypal.Button.render({
                            env: process.env.NODE_ENV === 'production' ? 'production' : 'sandbox',

                            payment: function() {
                                return paypalCheckoutInstance.createPayment({
                                    flow: 'vault',
                                    amount: this.pricePaid,
                                    currency: 'USD'
                                });
                            }.bind(this),
                            style: {
                                color: 'blue',
                                size:  'medium',
                                shape: 'rect'
                            },
                            onAuthorize: function(data, actions) {
                                // some logic here before tokenization happens below
                                return paypalCheckoutInstance.tokenizePayment(data).then(function(payload) {
                                    this.paypalPayload = payload;
                                    this.updateSubscriptionPaypal();
                                }.bind(this));
                            }.bind(this)
                        }, '#paypal-button');
                    }.bind(this));

                    braintree.hostedFields.create({
                        client: clientInstance,
                        styles: {
                            'input': {
                                'color': '#ffffff',
                                'font-size': '11px'
                            }
                        },
                        fields: {
                            cvv: {
                                placeholder: '123',
                                selector: '#card-cvv'
                            },
                            expirationDate: {
                                placeholder: 'MM/YYYY',
                                selector: '#card-expiry'
                            },
                            number: {
                                placeholder: 'XXXX XXXX XXXX XXXX',
                                selector: '#card-number'
                            }
                        }
                    }, function(err, hostedFieldsInstance) {
                        if (err) {
                            console.error(err);
                            return;
                        }

                        hostedFieldsInstance.on('validityChange', function(event) {
                            let field = event.fields[event.emittedBy];

                            if (field.isValid) {
                                if (event.emittedBy === 'cvv') {
                                    this.cardError.cvv = null;
                                    this.cardValid.cvv = true;
                                } else if (event.emittedBy === 'expirationDate') {
                                    this.cardError.expiry = null;
                                    this.cardValid.expiry = true;
                                } else if (event.emittedBy === 'number') {
                                    this.cardError.number = null;
                                    this.cardValid.number = true;
                                }
                            } else if (field.isPotentiallyValid) {
                                if (event.emittedBy === 'cvv') {
                                    this.cardError.cvv = null;
                                    this.cardValid.cvv = false;
                                } else if (event.emittedBy === 'expirationDate') {
                                    this.cardError.expiry = null;
                                    this.cardValid.expiry = false;
                                } else if (event.emittedBy === 'number') {
                                    this.cardError.number = null;
                                    this.cardValid.number = false;
                                }
                            } else {
                                if (event.emittedBy === 'cvv') {
                                    this.cardError.cvv = 'Invalid CVV';
                                    this.cardValid.cvv = false;
                                } else if (event.emittedBy === 'expirationDate') {
                                    this.cardError.expiry = 'Invalid expiry date';
                                    this.cardValid.expiry = false;
                                } else if (event.emittedBy === 'number') {
                                    this.cardError.number = 'Invalid credit card number';
                                    this.cardValid.number = false;
                                }
                            }

                            let formValid = true;
                            for (let key in this.cardValid) {
                                if (this.cardValid.hasOwnProperty(key)) {
                                    if (!this.cardValid[key]) {
                                        formValid = false;
                                    }
                                }
                            }

                            this.actionDisabled = !formValid;
                        }.bind(this));

                        hostedFieldsInstance.on('cardTypeChange', function(event) {
                            this.cardType = event.cards.length === 1 ? event.cards[0].niceType : null;
                        }.bind(this));

                        this.hostedFields = hostedFieldsInstance;
                    }.bind(this));
                }.bind(this));
            },
            cancelSubscription: function () {
                eventBus.$emit('show-loader');

                this.$http.post('/api/subscription/cancel', {
                    nonce: 'cancel',
                    plan: this.selectedPlan,
                    user: JSON.parse(user)
                }).then(function() {
                    eventBus.$emit('hide-loader');

                    window.location.href= '/subscription?alert=%7B%22message%22%3A%22Your+subscription+has+been+successfully+cancelled.+It+will+no+longer+automatically+renew+at+the+end+of+current+billing+cycle.%22%2C%22title%22%3A%22Success%22%2C%22type%22%3A%22success%22%7D';
                }, function() {
                    console.error('ERROR: there was an error cancelling subscription.');

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            'event': 'error',
                            'error': 'There was an error cancelling subscription.'
                        });
                    }

                    eventBus.$emit('hide-loader');
                });
            },
            computePrice: function () {
                this.pricePaid = this.selectedPlan === 'yearly'
                    ? this.priceYearly
                    : this.priceMonthly;

                if (this.coupon) {
                    this.pricePaid -= this.coupon.amount;

                    if (this.pricePaid < 0) {
                        this.pricePaid = 0;
                    }
                }
            },
            gotoStep: function (step) {
                this.actionDisabled = true;
                this.step = step;

                if (step === 1) {
                    this.pushGtmProductInfo();
                } else {
                    this.pushGtmAddToCart();
                    this.pushGtmCheckout();
                }
            },
            pushGtmAddToCart: function () {
                if (!window.dataLayer) {
                    return;
                }

                window.dataLayer.push({
                    'event': 'addToCart',
                    'ecommerce': {
                        'currencyCode': 'USD',
                        'add': {
                            'products': [{
                                'brand': 'Centralized',
                                'category': 'Subscription',
                                'id': '1',
                                'name': 'Subscription plan',
                                'price': this.pricePaid,
                                'quantity': 1,
                                'variant': 'centralized'
                            }]
                        }
                    }
                });
            },
            pushGtmCheckout: function () {
                if (!window.dataLayer) {
                    return;
                }

                window.dataLayer.push({
                    'event': 'checkout',
                    'ecommerce': {
                        'currencyCode': 'USD',
                        'checkout': {
                            'actionField': {
                                'option': this.cardType,
                                'step': 1
                            },
                            'products': [{
                                'brand': 'Centralized',
                                'category': 'Subscription',
                                'id': this.selectedPlan === 'yearly' ? '12' : '1',
                                'name': 'Subscription plan',
                                'price': this.pricePaid,
                                'quantity': 1,
                                'variant': this.selectedPlan
                            }]
                        }
                    }
                });
            },
            pushGtmProductInfo: function () {
                if (!window.dataLayer) {
                    return;
                }

                window.dataLayer.push({
                    'event': 'productDetail',
                    'ecommerce': {
                        'currencyCode': 'USD',
                        'detail': {
                            'actionField': {
                                'list': 'Purchase Subscription Page'
                            },
                            'products': [{
                                'brand': 'Centralized',
                                'category': 'Subscription',
                                'id': '1',
                                'name': 'Subscription plan',
                                'price': this.pricePaid,
                                'quantity': 1,
                                'variant': 'subscription'
                            }]
                        }
                    }
                });
            },
            selectPlan: function (plan) {
                this.selectedPlan = plan;
                this.coupon = null;
                this.couponCode = null;

                this.actionDisabled = this.isSubscribed && this.selectedPlan === this.currentPlan;

                this.computePrice();
            },
            updateSubscription: function (e) {
                e.preventDefault();

                if (!this.isSubscribed) {
                    if (this.pricePaid !== 0) {
                        this.hostedFields.tokenize(function (err, payload) {
                            if (err) {
                                console.error(err);

                                if (window.dataLayer) {
                                    window.dataLayer.push({
                                        'event': 'error',
                                        'error': 'There was an error setting up Braintree.'
                                    });
                                }

                                return;
                            }

                            eventBus.$emit('show-loader');

                            this.$http.post('/api/subscription/subscribe', {
                                coupon: this.coupon ? this.coupon.braintree_discount_id : null,
                                nonce: payload.nonce,
                                plan: this.selectedPlan,
                                user: JSON.parse(user)
                            }).then(function () {
                                eventBus.$emit('hide-loader');

                                if (this.coupon) {
                                    window.location.href = '/subscription/thank-you?plan=' + this.selectedPlan + '&price=' + this.pricePaid + '&coupon=' + this.coupon.code + '&provider=card';
                                } else {
                                    window.location.href = '/subscription/thank-you?plan=' + this.selectedPlan + '&price=' + this.pricePaid + '&provider=card';
                                }
                            }.bind(this), function () {
                                console.error('ERROR: there was an error creating subscription.');

                                if (window.dataLayer) {
                                    window.dataLayer.push({
                                        'event': 'error',
                                        'error': 'There was an error creating subscription.'
                                    });
                                }

                                eventBus.$emit('hide-loader');
                            });
                        }.bind(this));
                    } else {
                        eventBus.$emit('show-loader');

                        this.$http.post('/api/subscription/subscribe', {
                            coupon: this.coupon ? this.coupon.braintree_discount_id : null,
                            nonce: 'nopayment',
                            plan: this.selectedPlan,
                            user: JSON.parse(user)
                        }).then(function () {
                            eventBus.$emit('hide-loader');

                            window.location.href = '/subscription/thank-you?plan=' + this.selectedPlan + '&price=' + this.pricePaid + '&coupon=' + this.coupon.code + '&provider=card';
                        }.bind(this), function () {
                            console.error('ERROR: there was an error creating subscription.');

                            if (window.dataLayer) {
                                window.dataLayer.push({
                                    'event': 'error',
                                    'error': 'There was an error creating subscription.'
                                });
                            }

                            eventBus.$emit('hide-loader');
                        });
                    }
                } else {
                    eventBus.$emit('show-loader');

                    this.$http.post('/api/subscription/change-plan', {
                        nonce: 'swap',
                        plan: this.selectedPlan,
                        user: JSON.parse(user)
                    }).then(function() {
                        eventBus.$emit('hide-loader');

                        window.location.href= '/subscription?alert=%7B%22message%22%3A%22Your++successfully+changed+your+subscription+plan.%22%2C%22title%22%3A%22Success%22%2C%22type%22%3A%22success%22%7D';
                    }, function() {
                        console.error('ERROR: there was an error creating subscription.');

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'error',
                                'error': 'There was an error creating subscription.'
                            });
                        }

                        this.cardError.number = 'There was an error processing credit card';

                        eventBus.$emit('hide-loader');
                    });

                }
            },
            updateSubscriptionPaypal: function () {
                if (!this.isSubscribed) {
                    eventBus.$emit('show-loader');

                    this.$http.post('/api/subscription/subscribe', {
                        coupon: this.coupon ? this.coupon.braintree_discount_id : null,
                        nonce: this.paypalPayload.nonce,
                        plan: this.selectedPlan,
                        user: JSON.parse(user)
                    }).then(function() {
                        eventBus.$emit('hide-loader');

                        if (this.coupon) {
                            window.location.href = '/subscription/thank-you?plan=' + this.selectedPlan + '&price=' + this.pricePaid + '&coupon=' + this.coupon.code + '&provider=paypal';
                        } else {
                            window.location.href = '/subscription/thank-you?plan=' + this.selectedPlan + '&price=' + this.pricePaid + '&provider=paypal';
                        }
                    }.bind(this), function() {
                        console.error('ERROR: there was an error creating subscription.');

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'error',
                                'error': 'There was an error creating subscription.'
                            });
                        }

                        eventBus.$emit('hide-loader');
                    });
                } else {
                    eventBus.$emit('show-loader');

                    this.$http.post('/api/subscription/change-plan', {
                        nonce: 'swap',
                        plan: this.selectedPlan,
                        user: JSON.parse(user)
                    }).then(function() {
                        eventBus.$emit('hide-loader');

                        window.location.href= '/subscription?alert=%7B%22message%22%3A%22Your++successfully+changed+your+subscription+plan.%22%2C%22title%22%3A%22Success%22%2C%22type%22%3A%22success%22%7D';
                    }, function() {
                        console.error('ERROR: there was an error creating subscription.');

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'error',
                                'error': 'There was an error creating subscription.'
                            });
                        }

                        this.cardError.number = 'There was an error processing credit card';

                        eventBus.$emit('hide-loader');
                    });

                }
            }
        },
        props: {
            braintreeAuthorization: {
                required: true,
                type: String
            },
            currentPlan: {
                type: String
            },
            isOnGracePeriod: {
                required: true,
                type: Boolean
            },
            isSubscribed: {
                required: true,
                type: Boolean
            },
            priceMonthly: {
                required: true,
                type: Number
            },
            priceYearly: {
                required: true,
                type: Number
            },
            trialLength: {
                required: true,
                type: Number
            }
        }
    }
</script>
